import {EventEmitter, Injectable, Output} from '@angular/core';
import {ConfService} from './conf.service';
import {ConnecttocrudService} from './connecttocrud.service';

@Injectable({
  providedIn: 'root'
})
export class LeftpanelListenerService {

    @Output() leftpanelListener: EventEmitter<any> = new EventEmitter();


    constructor(private confPost: ConfService, private _service: ConnecttocrudService) {
    this.leftpanelListener.subscribe(
        (eventObject) => {
            // This Listener has to be removed
        }
    );
  }
}
